import { render, staticRenderFns } from "./LinkOrder.vue?vue&type=template&id=0d5b5e98"
import script from "./LinkOrder.vue?vue&type=script&lang=js"
export * from "./LinkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports